<template>
  <div class="go-in">
    <banner :img="innerBanner" title="走进星启仪" />
    <div class="section">
      <div class="section-content">
        <div class="content-summary">
          <div class="summary-left">
            <p class="title">公司简介</p>
            <p class="eTitle">ABOUT US</p>
            <p class="content">
              安徽星启仪实验室设备有限公司是一家集实验室规划设计、设备研发、生产制造、工程安装及售后服务于一体的现代化高新技术企业。公司以“创新驱动、品质为本、服务至上”为核心理念，致力于为科研机构、高校、医药、化工、环保等行业提供安全、智能、环保的实验室整体解决方案。公司专注于实验室家具（全钢/钢木/铝木实验台、通风柜、药品柜等）、实验室通风系统、环保净化系统、洁净工程及实验室智能化管理系统的研发与生产。依托先进的生产基地和严格的质量管理体系（通过ISO9001、ISO14001认证），产品以高精度、耐腐蚀、环保节能为特色，符合国际标准（如美国SEFA协会标准）。
            </p>
          </div>
          <div class="summary-right">
            <img src="../assets/img/jianjietopmin.jpg" alt />
          </div>
        </div>
        <el-divider class="el-divider-active">
          <i class="el-icon-arrow-down el-icon-arrow-down-active"></i>
        </el-divider>
        <!-- 发展历程 -->
        <!-- <div class="content-course">
          <div class="top">
            <h3>公司资质</h3>
            <p>Company Qualification</p>
            <div class="border"></div>
          </div>
          <div class="course-time">
            <img src="../assets/img/Qualification.png" style="width: 100%;height: 520px;">
          </div>
        </div> -->

        <div class="content-culture">
          <h3>完成项目</h3>
          <h3>RARTNERS</h3>
          <ul style="margin-top: 10px;">
            <li style="float: left;width: 50%;margin-bottom: 5px;n" v-for="item in projectFinsh" :key="item">{{ item }}
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import innerBanner from "../assets/img/bgtop.jpg"
import Banner from "../components/Banner";
/* import { swiper, swiperSlide } from "vue-awesome-swiper"; */
export default {
  components: {
    Banner,
    /* swiper,
    swiperSlide */
  },
  data() {
    return {
      projectFinsh: ["南昌大学", "合肥中科芯超医学检验所有限公司", "南昌航空大学", "安徽八公山疾控中心", "江西师范大学", "武汉艾迪康PCR检测实验室", "江西农业大学", "吉安市第一人民医院", "江西方大钢铁集团有限公司", "望江县人民医院", "江西省公路工程检测中心", "九江学院附属医院", "星火有机硅", "泰州市中心血站", "宜春环保局", "厦门生物医药港医疗健康有限公司", "余干仁和医院",],
      innerBanner,
      /* loading: true, */
      honorList: [],
      partnerImg: [],
      courseList: [],
      teamItem: [],
      swiperOption: {
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        }
      },
      dialogTableVisible: false,
      dialogUrl: "",
      dialogTitle: ""
    };
  },
  mounted() {
  }
};
</script>

<style lang="scss" scoped>
* {
  margin: 0;
  padding: 0;
}

.go-in {
  width: 100%;
  height: 100%;
  background-color: #14679f;
  position: relative;
  overflow: hidden;

  .section {
    width: 100%;

    &-content {
      width: 1240px;
      margin: 0 auto;
      background-color: #c2daeb;

      .content-summary {
        //height: 500px;
        display: flex;
        justify-content: space-around;
        padding: 100px 0;

        .summary-left {
          width: 600px;

          .title {
            font-size: 25px;
            color: #e13834;
          }

          .eTitle {
            font-size: 17px;
            color: #e13834;
            padding: 20px 0;
          }

          .content {
            color: #3a8ee6;
            font-size: 14px;
            text-indent: 25px;
            line-height: 30px;
            font-family: 600;
            font-weight: 600;
          }
        }

        .summary-right {
          width: 400px;
          height: 310px;
          border: 2px solid #1d42b9;
          //animation: imgboxkey 4s infinite;
          border-radius: 10px;
          margin-top: 80px;
          text-align: center;

          img {
            width: 360px;
            height: 270px;
            margin-top: 20px;
            //animation: imgbo 4s infinite;
          }
        }
      }

      //发展历程
      .content-course {
        padding: 50px 0;

        .course-time {
          width: 1000px;
          height: 500px;
          margin: 20px auto;

          .swiper-container {
            height: 100%;
          }

          .time-show {
            width: 700px;
            height: 100%;
            margin: 0 auto;
            display: flex;

            .time-show-item {
              width: 350px;
              height: 100%;
              overflow: hidden;
              display: flex;
              flex-direction: column;

              .item-top,
              .item-bottom {
                height: 190px;
              }

              .item-bottom {

                // display: flex;
                // align-content: center;
                .item-bottom-content {
                  background-color: #1667a0;
                  margin: 20px 0;

                  p {
                    color: #fff;
                    text-align: center;
                    padding: 15px;
                  }
                }
              }
            }
          }
        }
      }

      //企业文化
      .content-culture {
        height: 350px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        padding-left: 100px;
        background-color: #c2daeb;

        h3 {
          color: #3c6088;
          font-size: 26px;
        }

        p {
          color: #3c6088;
          font-size: 26px;
          padding: 5px 0;
        }

        span {
          font-weight: 400;
          line-height: 36px;
          font-size: 18px;
          padding: 5px 0;
        }
      }

      //公司荣誉
      .content-honor {
        padding: 50px 0;

        .honor-show {
          width: 1000px;
          margin: 30px auto;
          display: flex;
          flex-wrap: wrap;
          justify-content: flex-start;
          align-content: flex-start;

          li {
            width: 220px;
            height: 320px;
            margin-left: 15px;
            list-style: none;
            border: 1px solid palegoldenrod;

            img {
              width: 100%;
              height: 100%;
            }
          }
        }

        p {
          text-align: center;
          color: #3c6088;
        }
      }

      //团队风采
      .content-team {
        padding: 50px 100px;

        .swiper-img {
          height: 400px;
          background: no-repeat center;
          background-size: cover;
        }
      }

      //合作伙伴
      .content-partner {
        padding: 50px 0;

        .partner-img {
          width: 950px;
          margin: 20px auto;
          display: flex;
          justify-content: flex-start;
          flex-wrap: wrap;

          li {
            width: 107px;
            height: 107px;
            list-style: none;
            margin: 10px 25px;

            img {
              width: 100%;
              height: 100%;
              border: 1px solid rgb(194, 218, 235);
            }
          }
        }
      }
    }
  }
}

@keyframes imgboxkey {
  0% {
    border: solid rgb(29, 66, 185) 2px;
  }

  40% {
    border: solid rgb(255, 255, 255) 2px;
  }

  60% {
    border: solid rgb(255, 255, 255) 2px;
  }

  100% {
    border: solid rgb(29, 66, 185) 2px;
  }
}

@keyframes imgbo {
  0% {
    transform: scale(1);
    box-shadow: 0px 0px 0px 0px #ababab;
  }

  50% {
    transform: scale(1.1);
    box-shadow: 0px 0px 10px 5px #ababab;
  }

  100% {
    transform: scale(1);
    box-shadow: 0px 0px 0px 0px #ababab;
  }
}

.el-divider--horizontal {
  margin: 1px 0;
}

.top {

  h3,
  p {
    text-align: center;
    color: #3c6088;
    font-weight: 400;
    padding: 10px 0;
  }

  h3 {
    font-size: 30px;
  }

  p {
    font-size: 20px;
  }

  .border {
    border-bottom: 1px solid #3c6088;
    width: 15%;
    margin: 0 auto;
  }
}

// .swiper-button-disabled {
//   display: none;
// }
.order {
  order: -1;
}

.order-top {
  order: 1;
}

.el-divider {
  background-color: red;
  height: 3px;

  .el-divider__text {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    padding: 0px;
    color: #fff;
    border: 3px solid red;
  }
}

.el-divider-active {
  background-color: #3c6088;
}

.honor-big-img {
  width: 100%;
  height: 100%;
  z-index: 10;
  text-align: center;
  padding-bottom: 20px;
  padding: 5%;

  //background-color: #14679f;
  .el-dialog__wrapper {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    overflow: auto;
    margin: 0;

    .el-dialog__body {
      overflow: hidden;

      img {
        width: 100%;
      }
    }
  }
}
</style>